export const STYLE = {
    OPEN: "open",
    CONTAINED: "contained",
} as const;

export const LAYOUT = {
    SINGLE: "single",
    TWO_UP: "2up",
} as const;
